import { Component, ElementRef, Input, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { ToolbarSettings } from '@m4u-angular/base/classes/BaseClasses';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { BottomSheetContentParams, BottomSheetContextMenuParams, BottomSheetService } from '@m4u-angular/core/framework/bottom-sheet.service';
import { SidebarService } from '@m4u-angular/core/framework/sidebar.service';
import { EnumApplicationMode } from '@m4u-angular/core/framework/sysenums.enum';
import { HistoryViewComponent } from '@m4u-angular/ui/components/general/history-view/historyview.component';
import { Subscription } from 'rxjs';

class State extends BaseState {
    ToolbarSettings: ToolbarSettings;
    ContextMenuItems: any[] = [];
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-page-toolbar-buttons',
    templateUrl: './page-toolbar-buttons.component.html',
    styleUrls: ['./page-toolbar-buttons.component.scss']
})
export class PageToolbarButtonsComponent extends BaseComponent<State> {
    @Input() PageComponentName: string;
    @Input() FilterTemplateRef: TemplateRef<any>;

    @ViewChild('historyView') protected historyViewDialog: HistoryViewComponent;

    private _subscriptions: Subscription[] = [];

    constructor(A: ServiceBagService,
        public element: ElementRef,
        private renderer: Renderer2,
        private sidebarService: SidebarService,
        private bottomSheetService: BottomSheetService) {
        super(A, 'PageToolbarButtonsComponent', State);
    }

    protected override OnInitComponent(): void {
        this._subscriptions.push(this.A.SysEvents.Toolbar.subscribe((toolbarSettings: ToolbarSettings) => {
            if (!toolbarSettings) return;
            if (this.PageComponentName === toolbarSettings.PageComponentName) {
                this.State.ToolbarSettings = toolbarSettings;
                this.InitContextMenuItems();
            }
        }));
    }

    InitContextMenuItems() {
        const contextMenuItems = this.State.ToolbarSettings.OnGetContextMenuItems();
        this.State.ContextMenuItems = contextMenuItems.map(x => {
            return {
                label: x.text,
                icon: x.icon,
                visible: x.visible,
                command: x.onClick,
                separator: (x as any).separator
            };
        });
    }

    IsShowContextMenuButton() {
        return this.A.AppConfigService.AppConfig.Mode === EnumApplicationMode.Standard
            && this.State.ContextMenuItems && this.State.ContextMenuItems.length;
    }

    OpenFilter() {
        if (this.A.Screen.IsMobile()) {
            const contentParams = new BottomSheetContentParams();
            contentParams.Name = 'Filters';
            contentParams.Title = this.RC('lblFilters');
            contentParams.Class = 'no-page-scroll';
            contentParams.Content = this.FilterTemplateRef;
            this.bottomSheetService.Show(contentParams, true);
        } else {
            let className = `filters-sidebar ${this.State.ToolbarSettings.CustomFilterCssClass || ''}`
            this.sidebarService.Show('Filters', this.RC('lblFilters'), this.FilterTemplateRef,
                this.State.ToolbarSettings.FilterPanelWidth, null, null, className);
        }
    }

    ExcelExport() {
        const gridExtender = this.GetGridExternder();
        gridExtender && gridExtender.ExportExcel();
    }

    Print(e) {
        if (this.State.ToolbarSettings?.OnPrintButtonClick) {
            this.State.ToolbarSettings.OnPrintButtonClick(e);
        } else {
            const gridExtender = this.GetGridExternder();
            gridExtender ? gridExtender.Print() : window.print();
        }
    }

    Share(e) {
        if (this.State.ToolbarSettings?.OnShareButtonClick) {
            this.State.ToolbarSettings.OnShareButtonClick(e);
        }
    }

    private GetGridExternder() {
        return typeof this.State.ToolbarSettings?.GridExtender === 'function' ? this.State.ToolbarSettings?.GridExtender() : this.State.ToolbarSettings?.GridExtender;
    }

    OnShowContextMenu(event, cm) {
        event.preventDefault();
        event.stopPropagation();

        if (this.A.Screen.IsMobile() && !this.State.ToolbarSettings?.ShowContextMenuAsUsualOnMobile) {
            const title = this.State.ToolbarSettings?.ContextMenuTitle || this.RC('titleChooseOption');
            const menuParams = new BottomSheetContextMenuParams();
            menuParams.Title = title;
            menuParams.Items = this.State.ContextMenuItems;
            this.bottomSheetService.ShowContextMenu(menuParams);
            return;
        }

        cm.show(event);
        return false;
    }

    OnContextMenuShow() {
        this.InitContextMenuItems();

        const contextMenuTitle = this.State.ToolbarSettings && this.State.ToolbarSettings.ContextMenuTitle;
        if (!contextMenuTitle) return;

        const pageContextMenuHeaderId = 'page-context-menu-header';
        const pageContextMenuHeader = document.getElementById(pageContextMenuHeaderId);
        if (!pageContextMenuHeader) {
            const contextMenuHeaderContainer = this.renderer.createElement('div');
            this.renderer.setProperty(contextMenuHeaderContainer, 'id', pageContextMenuHeaderId);
            this.renderer.setProperty(contextMenuHeaderContainer, 'innerHTML', contextMenuTitle);
            this.renderer.insertBefore(document.querySelector('.page-context-menu'), contextMenuHeaderContainer, document.querySelector('.page-context-menu p-contextmenusub'));
        }
    }

    ShowHistory(e, hs) {
        this.State.ToolbarSettings.Page.GetHistory().subscribe(history => {
            if (!history || history.length == 0) {
                this.UI.StopMessage(this.RC('lblHistoryNotFound'));
                return;
            }
            this.historyViewDialog.Entities = history;
            this.historyViewDialog.ShowDialogShort(undefined);
        });
    }

    protected override OnDestroyComponent(): void {
        this._subscriptions.forEach(x => x.unsubscribe());
    }
}
